import Button from "../../common/components/Button";
import TicketHeading from "./TicketHeading";

function RelatedTickets({ relatedTickets = [] }) {
  return (
    <div className="border mt-4">
      <TicketHeading label="Related Tickets" />

      <div className="my-1 text-sm px-4">
        {relatedTickets.length ? (
          <>
            {relatedTickets.map((ticket, i) => {
              const { ticket_id, topic } = ticket;

              return (
                <Button
                  className="my-2 text-primary hover:border-b border-primary block"
                  key={i}
                  onClick={() => {
                    const url = window.location.href + `?search=${ticket_id}`;
                    window.open(url, "_blank");
                  }}
                >
                  {ticket_id} - <span className="font-semibold">{topic}</span>
                </Button>
              );
            })}
          </>
        ) : (
          <div className="font-semibold text-gray-500 text-center py-2">
            No Related Tickets
          </div>
        )}
      </div>
    </div>
  );
}

export default RelatedTickets;
